export enum InternalIssueCategory {
  Bug = 'Bug',
  UiLayout = 'UI / Layout',
  Crash = 'Crash',
  Other = 'Other',
}

export enum InternalIssueSeverity {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export const INTERNAL_ISSUE_CATEGORIES: InternalIssueCategory[] = [
  InternalIssueCategory.Bug,
  InternalIssueCategory.UiLayout,
  InternalIssueCategory.Crash,
  InternalIssueCategory.Other,
];

export const INTERNAL_ISSUE_SEVERITIES: InternalIssueSeverity[] = [
  InternalIssueSeverity.Low,
  InternalIssueSeverity.Medium,
  InternalIssueSeverity.High,
];

export const INTERNAL_ISSUE_TEXT_MAX_LENGTH = 500;



// WEBPACK FOOTER //
// ./src/model/types/internal-issue-report-type.ts